var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8427,
    cy: 10.6431,
    r: 10.3716,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69317 11.1987H10.1217C10.1596 11.1987 10.196 11.2137 10.2228 11.2405C10.2495 11.2673 10.2646 11.3036 10.2646 11.3415V13.7701C10.2646 14.1646 10.5844 14.4844 10.9789 14.4844C11.3733 14.4844 11.6932 14.1646 11.6932 13.7701V11.3415C11.6932 11.3036 11.7082 11.2673 11.735 11.2405C11.7618 11.2137 11.7981 11.1987 11.836 11.1987H14.2646C14.6591 11.1987 14.9789 10.8788 14.9789 10.4844C14.9789 10.0899 14.6591 9.77009 14.2646 9.77009H11.836C11.7981 9.77009 11.7618 9.75504 11.735 9.72825C11.7082 9.70146 11.6932 9.66512 11.6932 9.62723V7.19866C11.6932 6.8042 11.3733 6.48438 10.9789 6.48438C10.5844 6.48438 10.2646 6.8042 10.2646 7.19866V9.62723C10.2646 9.66512 10.2495 9.70146 10.2228 9.72825C10.196 9.75504 10.1596 9.77009 10.1217 9.77009H7.69317C7.2987 9.77009 6.97888 10.0899 6.97888 10.4844C6.97888 10.8788 7.2987 11.1987 7.69317 11.1987Z",
    fill: "#9A9A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "matrix(-1 0 0 -1 14.9789 14.4844)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/AddCircle.40ded4dea1444594a0ec9e2f88f24706.svg";
export { ForwardRef as ReactComponent };